import React, { useState, useEffect } from 'react'
import favicon from "../assets/favicon.png"
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginAPI } from '../utils/api';
import loadingif from "../assets/loading-gif.gif";
import { Col, Form } from 'react-bootstrap';
import { FaRegHandPointRight } from "react-icons/fa";
import { FiSmartphone, FiUser, FiLock, FiEye, FiEyeOff } from "react-icons/fi";

// Center Head / TL toggle buttons ki styling (apne theme ke hisaab se rang badal sakte ho)
const tabCss = `
.auth-tabs{display:grid;grid-template-columns:1.35fr 1fr;gap:4px;padding:4px;margin:24px 0 16px;
  background:#eef2f7;border-radius:12px}
.auth-tab{padding:12px 6px;border:0;background:transparent;color:#5b6b84;border-radius:9px;
  font-weight:700;font-size:12px;letter-spacing:.02em;white-space:nowrap;cursor:pointer;transition:all .25s}
.auth-tab:hover{color:#f95d0f}
.auth-tab.active{background:linear-gradient(135deg,#ff9f0a,#f95d0f);color:#fff;box-shadow:0 6px 16px rgba(249,93,15,.3)}
.auth-mode{display:flex;justify-content:center;margin:0 0 14px}
.auth-mode .auth-pill{margin:0!important;position:static!important;transform:none!important}
.auth-eye{background:none;border:0;color:inherit;cursor:pointer;padding:0 6px;display:flex;align-items:center}
.auth-fade{animation:authfade .35s ease both}
@keyframes authfade{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
`;

const Home = () => {
    const [loginType, setLoginType] = useState('center'); // 'center' | 'tl'
    const [values, setInputValue] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    const centerid = localStorage.getItem('centerdata');
    const tlid = localStorage.getItem('tldata');
    
    useEffect(() => {
        if (centerid || tlid) {
            navigate("/center-tv");
        }
        else {
            navigate("/");
        }
    }, [centerid, tlid]);

    const switchType = (type) => {
        if (type === loginType) return;
        setLoginType(type);
        setInputValue({});
        setValidated(false);
        setShowPass(false);
        setLoading(false);
    };

    const handleInputs = e => {
        setInputValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };

    // ---------- Center Head : mobile number + OTP ----------
    const handleCenterSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            setLoading(true);
            loginAPI("tv-center-send-mobile-otp", { ...values, login_type: "center" }).then((res) => {
                if (res.data.status === 1) {
                    localStorage.removeItem("centerdata");
                    localStorage.removeItem("tldata");
                    localStorage.setItem("centermobile", values.center_mobile);
                    toast.success(res.data.msg);
                    setLoading(false);
                    navigate("/mobile-otp");
                }
                else {
                    setLoading(false);
                    toast.error(res.data.msg);
                }
            }).catch(() => {
                setLoading(false);
                toast.error("Something went wrong. Please try again.");
            });
        }
        setValidated(true);
    }

    // ---------- TL : employee id + password ----------
    const handleTLSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            setLoading(true);
            loginAPI("tv-tl-login", { ...values, login_type: "tl" }).then((res) => {
                if (res.data.status === 1) {
                    localStorage.removeItem("centerdata");
                    localStorage.removeItem("centermobile");
                    localStorage.setItem("tldata", JSON.stringify(res.data.data || {}));
                    toast.success(res.data.msg);
                    setLoading(false);
                    navigate("/center-tv");
                }
                else {
                    setLoading(false);
                    toast.error(res.data.msg);
                }
            }).catch(() => {
                setLoading(false);
                toast.error("Something went wrong. Please try again.");
            });
        }
        setValidated(true);
    }

    const isCenter = loginType === 'center';

    return (
        <div className="homePage">
            <Helmet>
                <title>{isCenter ? 'SATKARTAR:ADMIN::CENTER HEAD PANEL' : 'SATKARTAR:ADMIN::TL PANEL'}</title>
            </Helmet>
            <style>{tabCss}</style>
            <div className="auth-shell">
                <div className="user_card">
                    <div className="auth-card-inner">
                        <div className="auth-header">
                            <div className="brand_logo_container">
                                <img src={favicon} className="brand_logo" alt="Satkartar logo" />
                            </div>
                            <h1 className="loginname">{isCenter ? 'CENTER HEAD PANEL' : 'TL PANEL'}</h1>
                            <p className="auth-subtitle">{isCenter ? 'SECURE OTP AUTHENTICATION' : 'SECURE PASSWORD AUTHENTICATION'}</p>
                        </div>

                        <div className="auth-tabs">
                            <button type="button" className={`auth-tab ${isCenter ? 'active' : ''}`} onClick={() => switchType('center')}>
                                Login with Center Head
                            </button>
                            <button type="button" className={`auth-tab ${!isCenter ? 'active' : ''}`} onClick={() => switchType('tl')}>
                                Login with TL
                            </button>
                        </div>

                        <div className="auth-mode auth-fade" key={`mode-${loginType}`}>
                            <span className="auth-pill">
                                {isCenter ? <><FiSmartphone /> MOBILE LOGIN</> : <><FiUser /> EMP ID LOGIN</>}
                            </span>
                        </div>

                        <div className="form_container auth-fade" key={loginType}>
                            {isCenter ? (
                                <Form noValidate validated={validated} onSubmit={handleCenterSubmit}>
                                    <Form.Group as={Col} md="12" controlId="validationCustom01" className="mobileinput">
                                        <Form.Label>MOBILE NUMBER</Form.Label>
                                        <div className="auth-input-wrap">
                                            <FiSmartphone />
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Enter your 10-digit mobile"
                                                onChange={handleInputs}
                                                pattern="[6789][0-9]{9}"
                                                maxLength={10}
                                                minLength={10}
                                                name="center_mobile"
                                            />
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            <FaRegHandPointRight /> Please provide a valid mobile number
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <div className="login_container">
                                        {loading ?
                                            <button disabled={true} type="submit" className="btn login_btn">
                                                <img src={loadingif} alt="loading" style={{ width: "7%", marginTop: "-3px" }} /> SENDING...
                                            </button>
                                            :
                                            <button type="submit" className="btn login_btn">SEND MOBILE OTP</button>
                                        }
                                    </div>
                                </Form>
                            ) : (
                                <Form noValidate validated={validated} onSubmit={handleTLSubmit}>
                                    <Form.Group as={Col} md="12" controlId="tlEmpId" className="mobileinput">
                                        <Form.Label>EMPLOYEE ID</Form.Label>
                                        <div className="auth-input-wrap">
                                            <FiUser />
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Enter your Employee ID"
                                                onChange={handleInputs}
                                                name="emp_id"
                                                autoComplete="username"
                                            />
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            <FaRegHandPointRight /> Please enter your Employee ID
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="12" controlId="tlPassword" className="mobileinput mt-3">
                                        <Form.Label>PASSWORD</Form.Label>
                                        <div className="auth-input-wrap">
                                            <FiLock />
                                            <Form.Control
                                                required
                                                type={showPass ? 'text' : 'password'}
                                                placeholder="Enter your password"
                                                onChange={handleInputs}
                                                name="password"
                                                autoComplete="current-password"
                                            />
                                            <button type="button" className="auth-eye" onClick={() => setShowPass(s => !s)} aria-label="Show or hide password">
                                                {showPass ? <FiEyeOff /> : <FiEye />}
                                            </button>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            <FaRegHandPointRight /> Please enter your password
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <div className="login_container">
                                        {loading ?
                                            <button disabled={true} type="submit" className="btn login_btn">
                                                <img src={loadingif} alt="loading" style={{ width: "7%", marginTop: "-3px" }} /> LOGGING IN...
                                            </button>
                                            :
                                            <button type="submit" className="btn login_btn">LOGIN</button>
                                        }
                                    </div>
                                </Form>
                            )}
                        </div>
                        <p className="auth-footer">&copy; 2026 Sat kartar Life Limited.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
